var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "versionReleaseModal",
            size: this.size,
            "content-class": "menu-bg-blue-transparent-modal vr-modal",
            "body-class": "p-0",
            title: "Version Release Notes",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.checkSize()
            },
          },
        },
        [
          _c(
            "b-tabs",
            {
              attrs: {
                "content-class": "mt-2",
                pills: "",
                card: "",
                justified: "",
              },
            },
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "Add Version",
                    active: _vm.activeTab == "add",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addNewVersion("lg")
                    },
                  },
                },
                [
                  _c(
                    "b-card",
                    { staticClass: "menu-bg-blue-transparent" },
                    [
                      _c(
                        "b-container",
                        [
                          _c(
                            "b-row",
                            { staticClass: "py-2" },
                            [
                              _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "field px-5" },
                                  [
                                    _c("label", { attrs: { for: "version" } }, [
                                      _vm._v("Version *"),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      attrs: {
                                        name: "version",
                                        autocomplete: "off",
                                      },
                                      model: {
                                        value: _vm.form.version,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "version", $$v)
                                        },
                                        expression: "form.version",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "py-2" },
                            [
                              _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "field px-5" },
                                  [
                                    _c("label", [_vm._v("Release Date *")]),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "date",
                                        placeholder: "Release Date",
                                      },
                                      model: {
                                        value: _vm.form.date,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "date", $$v)
                                        },
                                        expression: "form.date",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.submitErrors.length
                        ? _c(
                            "b-container",
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  [
                                    _c("b", [
                                      _vm._v(
                                        "Please correct the following error(s):"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group",
                                      _vm._l(
                                        _vm.submitErrors,
                                        function (error) {
                                          return _c(
                                            "div",
                                            {
                                              key: error,
                                              staticClass: "alert alert-danger",
                                            },
                                            [
                                              _c("b-list-group-item", [
                                                _vm._v(_vm._s(error)),
                                              ]),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-md m-2",
                                  attrs: { variant: "primary", type: "submit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.checkVersion()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Submit\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "New Release Notes",
                    active: _vm.activeTab == "new",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addNewNote("lg")
                    },
                  },
                },
                [
                  _c(
                    "b-card",
                    { staticClass: "menu-bg-blue-transparent" },
                    [
                      _c(
                        "b-container",
                        [
                          _c(
                            "b-row",
                            { staticClass: "py-2" },
                            [
                              _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "field px-5" },
                                  [
                                    _c("label", { attrs: { for: "version" } }, [
                                      _vm._v("Version *"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-select",
                                      {
                                        on: {
                                          change: function ($event) {
                                            return _vm.getReleaseDate($event)
                                          },
                                        },
                                        model: {
                                          value: _vm.form.version_details,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "version_details",
                                              $$v
                                            )
                                          },
                                          expression: "form.version_details",
                                        },
                                      },
                                      _vm._l(
                                        this.versions,
                                        function (item, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: { value: item },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(item.version) +
                                                  "\n                    "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "py-2" },
                            [
                              _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "field px-5" },
                                  [
                                    _c("label", [_vm._v("Release Date ")]),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        placeholder: "Release Date",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.form.release_date,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "release_date",
                                            $$v
                                          )
                                        },
                                        expression: "form.release_date",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "py-2" },
                            [
                              _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "field px-5" },
                                  [
                                    _c("label", [_vm._v("Organization *")]),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-select",
                                      {
                                        model: {
                                          value: _vm.form.org,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "org", $$v)
                                          },
                                          expression: "form.org",
                                        },
                                      },
                                      _vm._l(
                                        this.organizations,
                                        function (org, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: { value: org.id },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(org.company_name) +
                                                  "\n                    "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "py-2" },
                            [
                              _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "field px-5" },
                                  [
                                    _c("label", { attrs: { for: "notes" } }, [
                                      _vm._v("Notes *"),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-form-textarea", {
                                      attrs: {
                                        name: "notes",
                                        type: "textarea",
                                        autocomplete: "off",
                                      },
                                      model: {
                                        value: _vm.form.notes,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "notes", $$v)
                                        },
                                        expression: "form.notes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.submitErrors.length
                        ? _c(
                            "b-container",
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  [
                                    _c("b", [
                                      _vm._v(
                                        "Please correct the following error(s):"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group",
                                      _vm._l(
                                        _vm.submitErrors,
                                        function (error) {
                                          return _c(
                                            "div",
                                            {
                                              key: error,
                                              staticClass: "alert alert-danger",
                                            },
                                            [
                                              _c("b-list-group-item", [
                                                _vm._v(_vm._s(error)),
                                              ]),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "text-center" },
                            [
                              !this.updateEntryID
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-md m-2",
                                      attrs: {
                                        variant: "primary",
                                        type: "submit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkForm()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Submit\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.updateEntryID
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-md m-2",
                                      attrs: {
                                        variant: "primary",
                                        type: "submit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkForm()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Update\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "Unreleased Notes",
                    active: _vm.activeTab == "unreleased",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.getUnreleasedVersion("lg")
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "pb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-md",
                              attrs: { variant: "danger", type: "submit" },
                              on: {
                                click: function ($event) {
                                  return _vm.release()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Release Notes\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("vue-bootstrap4-table", {
                    attrs: {
                      columns: _vm.releaseColumns,
                      config: _vm.releaseconfig,
                      rows: _vm.releaseRows,
                      classes: _vm.classes,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "Versions",
                    active: _vm.activeTab == "version",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showVersions("lg")
                    },
                  },
                },
                [
                  _c("vue-bootstrap4-table", {
                    attrs: {
                      rows: _vm.versionDetailsRows,
                      columns: _vm.versionDetailsColumns,
                      config: _vm.config,
                      classes: _vm.classes,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "Release Notes",
                    active: _vm.activeTab == "history",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.getReleaseVersions("xl")
                    },
                  },
                },
                [
                  _c("vue-bootstrap4-table", {
                    attrs: {
                      rows: _vm.versionRows,
                      columns: _vm.versionColumns,
                      config: _vm.config,
                      classes: _vm.classes,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "update",
                        fn: function (props) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "info" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateEntry(props.row)
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: {
                                    icon: ["fas", "pencil-alt"],
                                    size: "lg",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "delete",
                        fn: function (props) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteEntry(props.row)
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: { icon: ["fas", "minus"], size: "lg" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "Tutorials",
                    active: _vm.activeTab == "tutorial",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.getTutorials()
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "pb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-md",
                              attrs: { variant: "danger", type: "submit" },
                              on: {
                                click: function ($event) {
                                  return _vm.releaseTutorials()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Release Tutorials\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("vue-bootstrap4-table", {
                    attrs: {
                      rows: _vm.tutorialRows,
                      columns: _vm.tutorialColumns,
                      config: _vm.config,
                      classes: _vm.classes,
                      actions: _vm.tutorialsActions,
                    },
                    on: {
                      add: function ($event) {
                        return _vm.initAddTutorial()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "active",
                        fn: function (props) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: !props.row.active
                                    ? "primary"
                                    : "danger",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeTutorialVisibility(
                                      props.row
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    !props.row.active ? "PUBLISH" : "UNPUBLISH"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "update",
                        fn: function (props) {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn",
                                staticStyle: { color: "#063c6d" },
                                on: {
                                  click: function ($event) {
                                    return _vm.initUpdateTutorial(props.row)
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: {
                                    icon: ["fas", "pencil-alt"],
                                    size: "lg",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("MMP_TutorialsModal", {
        attrs: { tutorial: _vm.selectedTutorial },
        on: { refresh: _vm.getTutorials },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }